<div class="container-fluid delete-alerts-container">
    <button type="button" class="close dialog-close" (click)="closeModal()" id="btn-dialog-close">
        <i class="icon-edponline-Bra-071 font-size-23 dialog-close-icon"></i>
    </button>

    <div class="row d-flex flex-column mt-5 mb-4">
        <h6 class="delete-alerts mb-0">{{'edp.emarket.confirm.dialog.eliminar' | translate}}</h6>
        <h6 class="delete-alerts">{{'edp.emarket.confirm.dialog.alertas.definidos' | translate}}</h6>
    </div>

    <div>
        <button class="btn bg w-100" (click)="dialogRef.close(true)" id="btn-confirm">
            <span class="already-client">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
        </button>
    </div>

    <div class="mt-3">
        <button class="btn bg-2 w-100" (click)="dialogRef.close(false)" id="btn-cancel">
            <span class="not-client">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
        </button>
    </div>
</div>
